import { createElement } from 'react';
import { b as __rest, av as Selector$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Selector = function Selector(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(Selector$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
Selector.displayName = 'Selector';

export { Selector };
